import { useFormik } from 'formik';
import Field from '../field';
import { IField } from '@/types/forms';
import { useId, useMemo } from 'react';
import Button from '../UI/button';

import style from './formRestorePassword.module.scss';
import ErrorComponent from '../UI/errorField';
import { useTranslation } from 'react-i18next';

type Props = {
  initialValue: any;
  validationSchema: any;
  fields: IField[];
  textButton: string;
  submitFunction: (values: any) => void;
  link?: boolean;
  code?: string;
};

const FormRestorePassword: React.FC<Props> = ({
  initialValue,
  validationSchema,
  fields,
  textButton,
  submitFunction,
  link,
  code,
}) => {
  const { i18n } = useTranslation();
  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (link) {
        submitFunction({ ...values, link: getRedirectAddress() });
      } else {
        submitFunction({ password: values.password, code: code });
      }
    },
  });

  const id = useId();

  const getRedirectAddress = () =>
    `${window.location.origin}/${
     i18n.language === 'en' || i18n.language === 'ro' ? i18n.language : ''
    }/restorePassword`;

  const renderErrors = useMemo(() => {
    if (formik && formik.errors) {
      const errorArray = Object.values(formik.errors);
      return errorArray.map((error, index) => (
        <ErrorComponent key={index} error={error as string} />
      ));
    }
  }, [formik]);

  return (
    <form onSubmit={formik.handleSubmit} className={style.form}>
      {fields.map((field: IField) => (
        <div key={field.name} className={style.wrapper_field}>
          <Field
            id={id + field.name}
            label={field.label}
            type={field.type}
            name={field.name}
            placeholder={field.placeholder}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[field.name]}
            error={formik.errors[field.name]}
          />
        </div>
      ))}
      {renderErrors}
      <Button text={textButton} otherStyle={style.button} type='submit' />
    </form>
  );
};

export default FormRestorePassword;
